import styled from 'styled-components';
import { Flex } from 'UI';

export const SSearchHistoryItem = styled(Flex)`
  padding: 15px;
  margin-bottom: 30px;
  border: 1px solid ${({ theme }) => theme.color.grey85};
  white-space: nowrap;
  text-align: left;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
`;

export const CloseIconWrapper = styled.div`
  cursor: pointer;
`;

export const SItemActions = styled.div`
  position: relative;
  flex: 0 0 auto;
  white-space: normal;
`;

export const SOptionsButton = styled.button`
  width: 44px;
  height: 44px;
  border: none;
  border-radius: 22px;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  :hover {
    background: #f2f2f2;
  }
`;

export const SOptionsMenu = styled.div`
  position: absolute;
  top: 46px;
  right: 0;
  min-width: 190px;
  max-width: min(220px, 90vw);
  display: flex;
  flex-direction: column;
  white-space: normal;
  background: ${({ theme }) => theme.color.white};
  border: 1px solid ${({ theme }) => theme.color.grey85};
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.16);
  z-index: 3;
  padding: 6px;
  overflow: hidden;
`;

export const SOptionsMenuItem = styled.button`
  display: block;
  width: 100%;
  border: none;
  background: transparent;
  text-align: left;
  padding: 10px;
  border-radius: 6px;
  cursor: pointer;
  white-space: normal;
  box-sizing: border-box;
  font-size: 15px;
  line-height: 1.2;
  color: ${({ theme }) => theme.color.brand_black};

  :hover {
    background: ${({ theme }) => theme.color.grey95};
  }
`;
